import appStore from 'store'
import api from './api'

const store = {
  namespaced: true,
  state: {
    paramsTime: {
      startTime: '',
      endTime: '',
    },
    oneEchertsData: [],
    twoEchertsData: [],
    threeEchertsData: [],
    tradeStatisticTotal: {
      date: null,
      registerCount: 0,
      firstDepositNum: 0,
      positionUidCount: 0,
      positionCount: 0,
      channelCount: null,
      totalFee: 0,
      positionProfit: 0,
      totalProfit: null,
      depositAmount: 0,
      withdrawAmount: 0,
      otcDepositAmount: 0,
      otcWithdrawAmount: 0,
      totalDeposit: 0,
      userBalance: 0,
      feeDay: 0,
      profitWeek: 0,
      netProfit: 0,
      ptprofit: null,
      personalProfit: null,
      groupProfit: null,
      realProfit: null,
      withdrawFee: 0,
      tradeUserCount: 0,
    },
  },

  mutations: {
    setParamsTime(state, payload) {
      state.paramsTime = payload
    },
    setOneEchertsData(state, payload) {
      state.oneEchertsData = payload
    },
    setTwoEchertsData(state, payload) {
      state.twoEchertsData = payload
    },
    setThreeEchertsData(state, payload) {
      state.threeEchertsData = payload
    },
    seTtradeStatisticTotal(state, payload) {
      state.tradeStatisticTotal = payload
    },
  },
  actions: {
    fetchTradeStatisticTotal({ commit }, data) {
      api.getTradeStatisticTotal(data).then((res) => {
        if (res.code == 0) {
          commit('seTtradeStatisticTotal', res.data)
        }
      })
    },
  },
}

appStore.registerModule('transactionStatistics', store)
